import { DEFAULT_CONTENT_LANGUAGE, DEFAULT_CONSOLE_LANGUAGE } from 'Console/constants/appConstants';

import {
    MOBILE_DRAWER_OPEN,
    ACTIONS_DRAWER_IS_SHOWN,
    ACTIONS_DRAWER_IS_LOADING,
    ACTIONS_DRAWER_WRAPPER_IS_SHOWN,
    CHANGE_CONSOLE_LANGUAGE,
    CHANGE_CONTENT_LANGUAGE,
} from './constants';

const initialState = {
    mobileMenuOpened: false,
    actionDrawer: {
        isShown: false,
        isLoading: false,
    },
    drawerWrapperIsShown: false,
    language: {
        availableLocales: [
            { code: 'sk', label: 'Slovenčina' },
            { code: 'en', label: 'English' },
        ],
        consoleLanguage: DEFAULT_CONSOLE_LANGUAGE,
        contentLanguage: DEFAULT_CONTENT_LANGUAGE,
    },
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case MOBILE_DRAWER_OPEN:
            return {
                ...state,
                mobileMenuOpened: payload.isOpened,
            };

        case ACTIONS_DRAWER_IS_SHOWN:
            return {
                ...state,
                actionDrawer: {
                    ...state.actionDrawer,
                    isShown: payload.isShown,
                },
            };

        case ACTIONS_DRAWER_IS_LOADING:
            return {
                ...state,
                actionDrawer: {
                    ...state.actionDrawer,
                    isLoading: payload.isLoading,
                },
            };

        case ACTIONS_DRAWER_WRAPPER_IS_SHOWN:
            return {
                ...state,
                drawerWrapperIsShown: payload.isShown,
            };

        case CHANGE_CONSOLE_LANGUAGE: {
            return {
                ...state,
                language: {
                    ...state.language,
                    consoleLanguage: payload,
                },
            };
        }

        case CHANGE_CONTENT_LANGUAGE: {
            return {
                ...state,
                language: {
                    ...state.language,
                    contentLanguage: payload,
                },
            };
        }

        default:
            return state;
    }
};

export default reducer;
